<mat-dialog-content>
  <div *ngIf="label" fxLayout="column" fxLayoutAlign="start center">
    <div class="usmc-logo" mat-card-image></div>
    <h1>{{title}}</h1>
    <div class="dialog-message">
      {{message}}
    </div>
  </div>
  <ff-sync-log></ff-sync-log>
</mat-dialog-content>
<mat-dialog-actions>
  <div fxFlex fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="8px">
    <mat-progress-bar *ngIf= "progressBar" class="launch-progress" [mode]="mode"
      [value]="totalProgress"></mat-progress-bar>
    <button mat-raised-button mat-dialog-close color="primary" class="button-launch"
      [ngClass]="launchClass" [disabled]="downloading" *ngIf="!data.autoClose || errorState">{{launchText}}</button>
  </div>
</mat-dialog-actions>
